<template>
    <div style="height:600px;width:1000px;">












        <vue-draggable-resizable :ref="message_box" :id="message_box" :class="editable? '':'no_vdr'"  :x="setup.MESSAGE_BOX.X" :y="setup.MESSAGE_BOX.Y"  :w="setup.MESSAGE_BOX.WIDTH" :h="setup.MESSAGE_BOX.HEIGHT"  @dragging="onDrag" @resizing="onResize" :parent="true">
            <v-progress-linear
                    :value="raised_percentage"
                    :color="setup.BG_BOX.COLOR"
                    height="150"
                    :style="{'background-image':bg_image}"
                    style="height:100%;width:100%;background-size:cover;"
                    rounded
            >
                <p         style="margin-top: 10px;"           :class="'apply-font-message'+id_given"
                                        :style="{'font-size':setup.AMOUNT_BOX.FONT_SIZE +'px','color':setup.AMOUNT_BOX.COLOR+' !important'}" >
                    {{raised_message}}
                </p>
            </v-progress-linear>
        </vue-draggable-resizable>

        <font-picker
                :options="{
                                        name: 'message'+id_given
                                        }"
                style="visibility: hidden;"
                :active-font="setup.MESSAGE_BOX.FONT"
                :api-key="'AIzaSyDAiLD4uruyYeaub20yX_zJpWtagUarpWA'"
                class="font_pick"
        ></font-picker>



    </div>

</template>

<script>
    import FontPicker from 'font-picker-vue';
    export default {
        name: "GoalAlert",
        components: {
            FontPicker
        },
        props:["data","setup","editable","id_given","locked"],
        data: () => ({

            amount_box_height:"20px",
            message_box_height:"20px",
            name_box_height:"20px",
            is_scrolling:false,
            show_bg_i:false,
            show_message_i:false,
            show_amount_i:false,
            show_name_i:false,
            timeouts:[],
            gif:null,
            extra_raised:0









        }),
        mounted:function(){






        },
        computed:{

            raised_message:function(){
                let the_s=this.setup.AMOUNT_BOX.TEMPLATE.replace("<SUMMA>",this.raised).replace("<TOTAL>",this.setup.MAX_DONATION);;
                return the_s
            },

            name_box_message:function(){
                let the_s=this.setup.NAME_BOX.TEMPLATE.replace("<NAMN>",this.data.SENDER_NAME).replace("<SUMMA>",this.data.AMOUNT);
                return the_s
            },
            amount_box_message:function(){
                let the_s=this.setup.AMOUNT_BOX.TEMPLATE.replace("<NAMN>",this.data.SENDER_NAME).replace("<SUMMA>",this.data.AMOUNT);
                return the_s
            },

            bg_image:function(){
                if(this.setup.BG_BOX.IMAGE){
                    return `url("${this.setup.BG_BOX.IMAGE}")`
                }
                else if(this.setup.BG_BOX.GIF){
                    return `url("${this.setup.BG_BOX.GIF}")`
                }
                else{
                    return "none"
                }
            },





            bg_box:function(){
                return "bg_box"+this.id_given;
            },
            amount_box:function(){
                return "amount_box"+this.id_given;
            },
            message_box:function(){
                return "message_box"+this.id_given;
            },
            name_box:function(){
                return "name_box"+this.id_given;
            },
            img_box:function(){
                return "img_box"+this.id_given;
            },
            raised:function(){
                let initial_raised=parseInt(this.setup.MIN_DONATION);

                return initial_raised+this.extra_raised;
            },
            raised_percentage:function(){
                let goal=parseInt(this.setup.MAX_DONATION);

                return (this.raised/goal)*100;
            }


        },


        methods:{

            message:function(){
                let self=this;
                this.show_bg_i=false;
                this.show_message_i=false;
                this.show_amount_i=false;
                this.show_name_i=false;
                this.timeouts.forEach(function(timeout){
                    clearTimeout(timeout);
                });
                this.data.AMOUNT=parseInt(this.data.AMOUNT);
                this.data.MIN_DONATION=parseInt(this.data.MIN_DONATION);
                if(this.setup.MAX_DONATION!==null && this.setup.MAX_DONATION!=="Ingen"){
                    this.data.MAX_DONATION=parseInt(this.data.MAX_DONATION);
                }

                if((this.data.AMOUNT< this.setup.MIN_DONATION) || (this.data.AMOUNT>this.setup.MAX_DONATION && (this.setup.MAX_DONATION!==null && this.setup.MAX_DONATION!=="Ingen" && this.setup.MAX_DONATION!=="NaN")))
                {
                    console.log(this.setup.MIN_DONATION);
                    console.log(this.data.AMOUNT>this.setup.MAX_DONATION);
                    console.log(this.setup.MAX_DONATION!==null);
                    console.log(this.setup.MAX_DONATION!=="Ingen");

                    console.log("amount not in range kappa");
                    self.$emit("donation_done")

                }
                else{
                    //BG
                    if(this.setup.BG_BOX.GIF){
                        this.gif=this.setup.BG_BOX.GIF;
                        this.setup.BG_BOX.GIF="";
                        document.getElementById(this.img_box).src="";
                    }
                    this.timeouts.push(setTimeout(function(){
                        self.show_bg_i=true;
                        if(self.setup.BG_BOX.VIDEO){
                            self.$refs.bg_video.currentTime="0";
                            self.$refs.bg_video.play();
                        }
                        else if(self.setup.BG_BOX.GIF===""){

                            self.setup.BG_BOX.GIF=self.gif;

                        }


                    },self.setup.BG_BOX.RANGE[0]*1000));
                    this.timeouts.push(setTimeout(function(){
                        self.show_bg_i=false;
                    },self.setup.BG_BOX.RANGE[1]*1000))
                    //MESSAGE
                    this.timeouts.push(setTimeout(function(){
                        self.show_message_i=true;
                    },self.setup.MESSAGE_BOX.RANGE[0]*1000));
                    this.timeouts.push(setTimeout(function(){
                        self.show_message_i=false;
                    },self.setup.MESSAGE_BOX.RANGE[1]*1000))
                    //AMOUNT
                    this.timeouts.push(setTimeout(function(){
                        self.show_amount_i=true;
                    },self.setup.AMOUNT_BOX.RANGE[0]*1000));
                    this.timeouts.push(setTimeout(function(){
                        self.show_amount_i=false;
                    },self.setup.AMOUNT_BOX.RANGE[1]*1000))
                    //NAME
                    this.timeouts.push(setTimeout(function(){
                        self.show_name_i=true;
                    },self.setup.NAME_BOX.RANGE[0]*1000));
                    this.timeouts.push(setTimeout(function(){
                        self.show_name_i=false;
                    },self.setup.NAME_BOX.RANGE[1]*1000))
                    if(this.setup.SOUND){
                        let src=`https://hihat.io${this.setup.SOUND}`
                        var audio = new Audio(src);
                        audio.play();
                    }
                    if(this.setup.TTS!==false && parseInt(this.setup.MIN_TTS)<=this.data.AMOUNT){
                        this.speak();
                    }
                    setTimeout(function(){
                        self.$emit("donation_done")
                    },self.setup.DURATION*1000);
                }

            },





            reset_message:function(SETUP){
                this.$refs[this.message_box].top = SETUP.MESSAGE_BOX.Y;
                this.$refs[this.message_box].left = SETUP.MESSAGE_BOX.X;
                this.$refs[this.message_box].w = SETUP.MESSAGE_BOX.WIDTH;
                this.$refs[this.message_box].h = SETUP.MESSAGE_BOX.HEIGHT;
                this.$refs[this.message_box].width = SETUP.MESSAGE_BOX.WIDTH;
                this.$refs[this.message_box].height = SETUP.MESSAGE_BOX.HEIGHT;


                document.getElementById(this.message_box).style.transform = `translate(${SETUP.MESSAGE_BOX.X}px, ${SETUP.MESSAGE_BOX.Y}px)`;
                document.getElementById(this.message_box).style.width = `${SETUP.MESSAGE_BOX.WIDTH}px`;
                document.getElementById(this.message_box).style.height = `${SETUP.MESSAGE_BOX.HEIGHT}px`;
            },
            save:function(){
                let SETUP= {

                    "MESSAGE_BOX": {}
                }



                 SETUP.MESSAGE_BOX={
                     "X":this.$refs[this.message_box].left,
                     "Y":this.$refs[this.message_box].top,
                     "WIDTH":this.$refs[this.message_box].width,
                     "HEIGHT":this.$refs[this.message_box].height
                 };

                return SETUP


            },


            onResize: function (x, y, width, height) {
                this.x = x;
                this.y = y;
                this.width = width;
                this.height = height;
            },
            onDrag: function (x, y) {
                this.x = x;
                this.y = y;
            },

        },
        watch:{

        }

    }

</script>

<style>
    .ME_BIG > * {
        position: relative !important;
        min-height:100% !important;
        height:100% !important;
        max-height: 100% !important;
        box-shadow:none !important;
        -webkit-box-shadow: none !important;
        text-shadow: 0 0 3px #000000, 0 0 5px #000000;
    }
    .ME_BIG{
        position: relative !important;
        min-height:100% !important;
        height:100% !important;
        box-shadow:none !important;
        -webkit-box-shadow: none !important;

        max-height: 100% !important;
    }
    .ME_BIG > * textarea{
        box-shadow:none !important;
        -webkit-box-shadow: none !important;
        color: inherit !important;
        text-align: center;
        text-shadow: rgb(0, 0, 0) 0px 0px 3px, rgb(0, 0, 0) 0px 0px 5px;
    }
    .v-input__slot{
        box-shadow:none !important;
        -webkit-box-shadow: none !important;
    }

    ::-webkit-scrollbar {
        width: 0;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: transparent;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background:transparent;
    }

    .vdr{
        border: none !important;
    }

    textarea {
        resize: none;
    }

    .ff-image{
        height:100% !important;
        width:100% !important;
    }

    .ff-container{
        height:100% !important;
        width:100% !important;
    }


</style>
